export default __webpack_public_path__ + "static/media/fechadura-eletronica.f7c019c3.png";